/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useEffect, useMemo, useState, useCallback } from 'react';
import CustomTable from 'components/cmn/CustomTable';
import { DiagnosticTableHead } from 'components/cmn/CustomTableHeadWrapper';
import { useProject } from 'hooks/useProject';
import { SurveyListLatestContent } from 'interface/project/projectInfo';
import DiagnosticTableBody from './DiagnosticTableBody';

function DiagnosticTable(): JSX.Element {
  const [allLoading, setAllLoading] = useState(true);

  const { getInfiniteSurveyListLatest } = useProject();
  const { data: surveyData, size, setSize, isReachingEnd, isLoadingMore } = getInfiniteSurveyListLatest();

  const surveys: SurveyListLatestContent[] = useMemo(() => {
    return surveyData?.map(surveyListInfo => surveyListInfo.contents).reduce((pre, cur) => pre.concat(cur)) || [];
  }, [surveyData]);

  const loadMore = useCallback(() => {
    setSize(size + 1);
  }, [setSize, size]);

  useEffect(() => {
    if (allLoading && !isLoadingMore) {
      if (!isReachingEnd) {
        loadMore();
      } else {
        setAllLoading(false);
      }
    }
  }, [allLoading, isLoadingMore, isReachingEnd, loadMore]);

  return (
    <CustomTable maxHeight="calc(100vh - 385px)" isPagination={false}>
      <DiagnosticTableHead order="desc" orderBy="id" />
      <DiagnosticTableBody loading={allLoading} rows={surveys} duration={0} />
    </CustomTable>
  );
}

export default memo(DiagnosticTable);
